// LoginModal.tsx
import React, { Fragment } from 'react';
import { useAuthModal } from './authModalContext';
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import BottomSwiper from 'core/components/BottomSwiper';
import ButtonLoginSns from 'modules/Auth/pages/components/ButtonLoginSns';
import CloseIcon from 'core/assets/icons/commons/icon_close.svg';
import { RouterName } from "core/router";
import { _t } from "core/language";
// import { useLoginClient } from 'modules/Auth/hooks';

export const LoginModal: React.FC = () => {
  const { isModalOpen, closeModal, resetPrevAction } = useAuthModal();
  const navigate = useCustomNavigate();

  // const _onSuccess = () => {
  //   closeModal()
  // };

  // const _onFailed = (errors: any) => {
  //   console.log(errors)
  // };

  // const [handleLogin] = useLoginClient({
  //   onSuccess: _onSuccess,
  //   onFailed: _onFailed,
  // });

  const onGoToPage = (url:any) => {
    closeModal();
    navigate(url)
  };

  const _closeModal = () => {
    console.log('close modal')
    closeModal();
    resetPrevAction()
  };

  return (
    <Fragment>
      <BottomSwiper
        isOpen={isModalOpen}
        toggleDrawer={_closeModal}
        zIndex={50}
      >
        <div className={`mt-[24px] mb-[24px]`}>
          <button className="text-gray-400 hover:text-gray-600 absolute right-[16px] top-[16px]" onClick={_closeModal}>
            <img src={CloseIcon} className='' alt="close" />
          </button>
          <div className="flex flex-col">
              <p className="text-[15px] font-medium text-[#111111] mb-[34px] text-center" dangerouslySetInnerHTML={{__html: _t('auth.LabelModalLogin')}}></p>
            <div className="flex justify-center">
              <ButtonLoginSns btnText='show' popup={isModalOpen} closeModal={closeModal} />
            </div>
            <div className="flex justify-center mt-[24px]" onClick={() => { onGoToPage(RouterName.SIGNUP_POLICY+'?signUpModal=true') }}>
              <label className='text-[14px] text-[#555555] underline'>{_t('auth.LabelSignUp')}</label>
            </div>
            {/* <div className="flex flex-col gap-y-2 hidden">
              <Button
                label={_t('auth.LabelIdLogin')}
                classBtn="w-full"
                primary
                onClickBtn={() => onGoToPage(RouterName.LOGIN)}
                size="lg"
              />
              <Button
                label={_t('auth.LabelSignUp')}
                classBtn="w-full"
                outline
                onClickBtn={() => { onGoToPage(RouterName.SIGNUP_POLICY+'?signUpModal=true') }}
                size="lg"
              />
            </div> */}
          </div>
        </div>
      </BottomSwiper>

    </Fragment>
  );
};

export default LoginModal;
